export default {
    path: '/editors',
    name: 'Editors',
    meta: {
        requiresAuth: true,
        authorizedUsers: ['admin', 'editor']
    },
    component: () => import('./Editors')
}
